import configuration from '../config';
import { FAVORITES_ROUTE } from '../constants/index';

const post = async (token, favoriteId) => {
  const urlencoded = new URLSearchParams();
  urlencoded.append('favoriteId', favoriteId.toString());

  const response = await fetch(`${configuration.api.url}/${FAVORITES_ROUTE}`, {
    method: 'POST',
    body: urlencoded,

    headers: {
      Authorization: `Bearer ${token}`,
      'Max-Forwards': '0',
    },
  });

  if (!response.ok) {
    if (response.status !== 404) {
      const json = await response.json();
      if (json) {
        throw new Error(json?.message);
      }
      throw new Error('Invalid Response');
    }
    return null;
  }

  const json = await response.json();
  return json;
};

const get = async (token) => {
  const response = await fetch(`${configuration.api.url}/${FAVORITES_ROUTE}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Max-Forwards': '0',
    },
    method: 'GET',
  });

  if (!response.ok) {
    if (response.status !== 404) {
      throw new Error('Invalid response');
    }
    return null;
  }

  const json = await response.json();
  return json;
};

const put = async (token, favoriteId) => {
  const urlencoded = new URLSearchParams();

  urlencoded.append('favoriteId', favoriteId.toString());

  const response = await fetch(`${configuration.api.url}/${FAVORITES_ROUTE}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Max-Forwards': '0',
    },
    body: urlencoded,
    method: 'PUT',
  });

  if (!response.ok) {
    if (response.status !== 404) {
      throw new Error('Invalid response');
    }
    return null;
  }

  const json = await response.json();
  return json;
};

const Favorites = {
  post,
  put,
  get,
};

export default Favorites;
